<script lang="ts" setup>
const props = defineProps({
  linkTitle: String
})
</script>

<template>
  <button class="button">{{ props.linkTitle }}</button>
</template>

<style lang="scss" scoped>
.button {
  width: toRem(92);
  height: toRem(47);
  border-radius: toRem(50);
  font-size: toRem(16);
  font-weight: 700;
  line-height: 1.6;
  color: $color-white-1;
  background-color: $color-brand-4_1;
  border: none;

  @include max-media(440) {
    position: absolute;
    right: 0px;
  }
}
</style>
